module.exports = __webpack_public_path__ + "static/media/merida.4f72ce03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/centers/merida.png
// module id = 621
// module chunks = 0